import { ErrorHandler } from '@angular/core';
import { BugsnagService } from './bugsnag/bugsnag.service';

export function errorHandlerFactory(bugsnagService: BugsnagService) {
  const errorHandler = bugsnagService.createErrorHandler();
  return errorHandler ? errorHandler : new ErrorHandler();
}
